import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@lendcord/concord";
import { BranchesTab } from "./components/BranchesTab";
import { LoanSchemesTab } from "./components/LoanSchemesTab";
import { EnterpriseProfileTab } from "./components/EnterpriseProfileTab";

type SetupTab = "branches" | "loanPlans" | "enterpriseProfile";

// ENTERPRISE-only (see App.tsx's RequireRole navKey="setup"). Branch
// management is lendcord-core's BranchController; Loan Plans is
// LoanSchemeController's Stage-1 config CRUD (see
// docs/flows/loan-scheme-config.md in lendcord-core) — reference-data
// storage only, not yet wired to drive any lender/borrower journey field.
// Enterprise Profile is lendcord-core's EnterpriseBrandProfileController
// (see EnterpriseProfileTab).
export function SetupPage() {
  const [tab, setTab] = useState<SetupTab>("branches");

  return (
    <div className="p-4 sm:p-6">
      <Tabs value={tab} onValueChange={(value) => setTab(value as SetupTab)}>
        <TabsList className="mb-6 grid grid-cols-3 max-w-lg">
          <TabsTrigger value="branches">
            <FormattedMessage id="lender.setup.tabBranches" />
          </TabsTrigger>
          <TabsTrigger value="loanPlans">
            <FormattedMessage id="lender.setup.tabLoanPlans" />
          </TabsTrigger>
          <TabsTrigger value="enterpriseProfile">
            <FormattedMessage id="lender.setup.tabEnterpriseProfile" />
          </TabsTrigger>
        </TabsList>

        <TabsContent value="branches" className="mt-0">
          <BranchesTab />
        </TabsContent>

        <TabsContent value="loanPlans" className="mt-0">
          <LoanSchemesTab />
        </TabsContent>

        <TabsContent value="enterpriseProfile" className="mt-0">
          <EnterpriseProfileTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
